var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"new-vs-recurring"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('visitors.audience.userType')))])])}
var staticRenderFns = []

export { render, staticRenderFns }